import { render, staticRenderFns } from "./SectionB.vue?vue&type=template&id=2ecee804&scoped=true"
import script from "./SectionB.vue?vue&type=script&lang=js"
export * from "./SectionB.vue?vue&type=script&lang=js"
import style0 from "./SectionB.vue?vue&type=style&index=0&id=2ecee804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecee804",
  null
  
)

export default component.exports